import { VueLogger } from "vue-logger-plugin";
import type {LogLevel} from "vue-logger-plugin/dist/types/logger.ts";

class Logger extends VueLogger {
  constructor() {
    super({
      level: import.meta.env.FARM_LOG_LEVEL as LogLevel || 'error',
      enabled: true,
    });
  }

  debug(...args: any[]) {
    this.log('debug', ...args);
  }

  info(...args: any[]) {
    this.log('info', ...args);
  }

  warn(...args: any[]) {
    this.log('warn', ...args);
  }

  error(...args: any[]) {
    this.log('error', ...args);
  }
}

const loggerInstance = new Logger();

export default loggerInstance;
